export enum CheckPointType {
  VIDEO = 'VIDEO',
  PHOTO = 'PHOTO',
}

export type CheckPoint = {
  id: string;
  name: string;
  type: CheckPointType;
};
